if (!customElements.get('recently-viewed-products-section')) {
    // js/sections/RecentlyViewedProductsSection.js
    var import_flickity4 = __toESM(require_js());
    class RecentlyViewedProductsSection extends HTMLElement {
    constructor() {
        super();
        this.delegateElement = new main_default(this);
        this.options = JSON.parse(this.getAttribute("data-section-settings"));
        this.productItemColorSwatch = new ProductItemColorSwatch(this);
        this._fetchProducts();
        this._attachListeners();
    }
    onUnload() {
        if (this.flickityInstance) {
        this.flickityInstance.destroy();
        }
        this.productItemColorSwatch.destroy();
        if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        }
    }
    _attachListeners() {
        this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
    }
    /**
     * In order to get the products to display, we hit the search template with the given IDs.
     */
    _fetchProducts() {
        const queryString = this._getSearchQueryString();
        if (queryString === "") {
        return;
        }
        fetch(`${window.routes.searchUrl}?section_id=${this.getAttribute("data-section-id")}&type=product&q=${queryString}`, {
        credentials: "same-origin",
        method: "GET"
        }).then((response) => {
        response.text().then((content) => {
            let tempElement = document.createElement("div");
            tempElement.innerHTML = content;
            this.querySelector(".recently-viewed-products-placeholder").innerHTML = tempElement.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML;
            this.parentNode.style.display = "block";
            this.productItemColorSwatch.recalculateSwatches();
            this.flickityInstance = new import_flickity4.default(this.querySelector(".product-list"), {
            watchCSS: true,
            pageDots: false,
            prevNextButtons: true,
            contain: true,
            resize: false,
            groupCells: true,
            cellAlign: "left",
            draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches
            });
            let lastWidth = window.innerWidth;
            window.addEventListener("resize", () => {
            if (window.innerWidth !== lastWidth) {
                this.flickityInstance.resize();
                lastWidth = window.innerWidth;
            }
            });
            if (window.ResizeObserver && this.flickityInstance) {
            this.resizeObserver = new ResizeObserver(() => {
                this.flickityInstance.resize();
            });
            this.querySelectorAll(".product-item").forEach((item) => {
                this.resizeObserver.observe(item);
            });
            }
        });
        });
    }
    _getSearchQueryString() {
        let items = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
        if (items.includes(this.options["currentProductId"])) {
        items.splice(items.indexOf(this.options["currentProductId"]), 1);
        }
        return items.map((item) => {
        return "id:" + item;
        }).join(" OR ");
    }
    _openQuickView(event2, target) {
        let productUrl = new URL(`${window.location.origin}${target.getAttribute("data-product-url")}`);
        if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) {
        window.location.href = productUrl.href;
        return false;
        }
        let modal = document.getElementById(target.getAttribute("aria-controls"));
        modal.classList.add("is-loading");
        productUrl.searchParams.set("view", "quick-view");
        fetch(productUrl.href, {
        credentials: "same-origin",
        method: "GET"
        }).then((response) => {
        response.text().then((content) => {
            modal.querySelector(".modal__inner").innerHTML = content;
            modal.classList.remove("is-loading");
            let modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]'));
            let doCleanUp = () => {
            modalProductSection.onUnload();
            modal.removeEventListener("modal:closed", doCleanUp);
            };
            modal.addEventListener("modal:closed", doCleanUp);
        });
        });
    }
    /**
     * ---------------------------------------------------------------------------------------------------
     * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
     * ---------------------------------------------------------------------------------------------------
     */
    _addToCart(event2, target) {
        if (window.theme.cartType === "page") {
        return;
        }
        event2.preventDefault();
        event2.stopPropagation();
        target.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        const formElement = target.closest('form[action*="/cart/add"]');
        fetch(`${window.routes.cartAddUrl}.js`, {
        body: JSON.stringify(Form.serialize(formElement)),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
        }
        }).then((response) => {
        target.removeAttribute("disabled");
        if (response.ok) {
            this.dispatchEvent(new CustomEvent("product:added", {
            bubbles: true,
            detail: {
                button: target,
                variant: null,
                quantity: parseInt(formElement.querySelector('[name="quantity"]').value)
            }
            }));
        } else {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }
        });
        event2.preventDefault();
    }
    };

    customElements.define('recently-viewed-products-section', RecentlyViewedProductsSection);
}